import { SkeletonContext } from './context';
import { type ReactNode } from 'react';

export function SkeletonProvider({ children, isLoading }: { children: ReactNode; isLoading: boolean }) {
  return <SkeletonContext.Provider value={isLoading}>{children}</SkeletonContext.Provider>;
}
